/* Meal menu additions stay on the current page. Never resubmit a failed
   request: the server may already have added the meal. */
(function () {
  'use strict';

  var SEL = 'form[action$="/cart/add"]';
  var RESET_MS = 1800;

  /* Horizon puts the cart count in more than one place depending on
     header layout, and a bare number sits in some of them. Update
     every candidate rather than guess which one this theme uses. */
  var COUNT_SEL = [
    '.cart-bubble__text',
    '[data-cart-count]',
    '.cart-count-bubble span[aria-hidden]',
    '.header__cart-count',
    '.cart-count'
  ].join(',');

  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('p');
      live.setAttribute('aria-live', 'polite');
      /* visually hidden without depending on a theme class */
      live.style.cssText =
        'position:absolute;width:1px;height:1px;margin:-1px;padding:0;' +
        'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
      document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  function paintCount(n) {
    var nativeIcons = document.querySelectorAll('cart-icon');
    if (nativeIcons.length) {
      nativeIcons.forEach(function (icon) {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(n, true);
          return;
        }
        var bubble = icon.querySelector('.cart-bubble');
        var count = icon.querySelector('.cart-bubble__text-count');
        if (count) {
          count.textContent = n < 100 ? String(n) : '';
          count.classList.toggle('hidden', n === 0);
        }
        if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
        icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
      });
    } else {
      document.querySelectorAll('[data-cart-count], .header__cart-count, .cart-count').forEach(function (el) {
        el.textContent = String(n);
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(n));
      });
    }
    ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  function flyMealToCart(form) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var card = form.closest('.mp-meal, article, .card');
    var source = card && card.querySelector('img');
    var cart = document.querySelector('a[href="/cart"] cart-icon, cart-icon');
    if (!source || !cart || typeof source.getBoundingClientRect !== 'function') return;

    var from = source.getBoundingClientRect();
    var to = cart.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var bubble = document.createElement('div');
    bubble.setAttribute('aria-hidden', 'true');
    bubble.style.cssText =
      'position:fixed;z-index:2147483000;pointer-events:none;overflow:hidden;' +
      'width:64px;height:64px;border-radius:50%;border:3px solid #C2C15D;' +
      'background:#222 center/cover no-repeat;box-shadow:0 8px 30px rgba(0,0,0,.55);' +
      'left:' + (from.left + from.width / 2 - 32) + 'px;top:' + (from.top + from.height / 2 - 32) + 'px;' +
      'background-image:url("' + String(source.currentSrc || source.src).replace(/"/g, '%22') + '")';
    document.body.appendChild(bubble);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    bubble.setAttribute('data-mp-cart-fly', '');
    bubble.style.transition = 'transform 720ms cubic-bezier(.22,.75,.25,1), opacity 720ms ease';
    bubble.style.transform = 'translate(0,0) scale(1)';
    bubble.style.opacity = '1';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        bubble.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.18)';
        bubble.style.opacity = '.2';
      });
    });
    window.setTimeout(function () { if (bubble.parentNode) bubble.remove(); }, 820);
  }

  function refreshCount() {
    return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + 'cart.js'
        : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not refresh cart');
        return r.json();
      })
      .then(function (cart) { paintCount(cart.item_count); return cart; });
  }

  /* The homepage plan builder adds several lines in one request. Share the
     same proven counter refresh so the header never shows a stale quantity. */
  window.MP_refreshCartCount = refreshCount;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest(SEL) : null;
    if (!form || e.defaultPrevented || form.closest('product-form-component')) return;

    var btn = form.querySelector('button[type="submit"], .mp-add');
    if (btn && btn.disabled) { e.preventDefault(); return; }

    e.preventDefault();

    var original = btn ? btn.innerHTML : '';
    var confirmed = false;
    var feedback = form.querySelector('[data-mp-add-feedback]');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.setAttribute('data-mp-add-feedback', '');
      feedback.setAttribute('role', 'status');
      feedback.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.35;grid-column:1/-1;';
      form.appendChild(feedback);
    }
    feedback.hidden = true;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding...';
    }

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (item) {
          if (!r.ok || item.status) {
            var error = new Error(typeof item.description === 'string' ? item.description : 'This meal could not be added.');
            error.cartDeclined = true;
            throw error;
          }
          return item;
        });
      })
      .then(function (item) {
        confirmed = true;
        if (btn) btn.textContent = 'Added';
        announce((item && item.title ? item.title : 'Meal') + ' added to your box.');
        flyMealToCart(form);
        return refreshCount();
      })
      .catch(function (error) {
        var message = confirmed
          ? 'Meal added. Open your cart to check the latest total.'
          : error.cartDeclined
            ? error.message
            : 'We could not confirm the addition. Check your cart before trying again.';
        feedback.textContent = message;
        feedback.hidden = false;
        announce(message);
      })
      .finally(function () {
        window.setTimeout(function () {
          if (!btn) return;
          btn.disabled = false;
          btn.innerHTML = original;
        }, confirmed ? RESET_MS : 0);
      });
  });
})();
